import PricingCards from '@/components/PricingCards'
import { PricingUsageDetails } from 'shared-web/components/PricingUsageDetails'

export default function PricingSection() {
  return (
    <>
      <section id="pricing" className="p-4 lg:py-26 py-12 bg-white text-black">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="sm:text-sm text-3xl md:text-4xl font-bold mb-4">Simple, Transparent Pricing</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">Choose the plan that works best for you and your team</p>
          </div>

          <PricingCards />
        </div>

        <PricingUsageDetails />

        <div className="container mx-auto">
          <div className="bg-white border border-purple-200 rounded-xl p-8 text-center shadow-sm">
            <div className="flex items-center justify-center mb-4">
              <h3 className="lg:text-lg font-bold text-purple-900">Enterprise Plans Coming Soon</h3>
            </div>
            <p className="lg:text-lg text-purple-700 max-w-4xl mx-auto">
              We're working on enterprise plans that will be available in the future for organizations with advanced needs. If you'd like
              more information on Lavender Flow for your business, we'd love to chat.
            </p>
          </div>
        </div>
      </section>
    </>
  )
}
